// Paint Dashboard routes (TV / fullscreen).
import React from "react";

const ShowPaintDashboard = React.lazy(() => import("./show"));

export default [
  {
    path: "/production/paint_dashboard",
    component: ShowPaintDashboard,
    name: "Paint Dashboard",
  },
];
